import appSettings from "../settings/appSettings";
import { RequestKeyResponse } from "../types";

export async function getRequestKey(): Promise<string> {
  const { ajaxUrl, action } = appSettings.requestKeyConfig || {};

  const requestData = {
    action: action
  };

  const requestKey = await new Promise((resolve) => {
    window.jQuery.post(
      ajaxUrl,
      requestData,
      function (response: RequestKeyResponse) {
        resolve(response?.data?.requestKey);
      },
      "json"
    );
  });

  return requestKey as string;
}
